import { useEffect } from 'react';
import './App.css';

import reactLogo from './react-logo.gif';
import { Navigate, useNavigate } from 'react-router';


function App() {
  
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login")
  }, []);

  return (
    <div className='Introduction'>
      <text>Hello, Welcome to the cool pirate studio app!</text>
      <text>If ur seeing, this, ur about to be redirected to the editing page</text>
      <text >Later :)</text>
      <img src={reactLogo}/>
    </div>
  );
}

export default App;